import {Deserializable} from "./deserializable.model";

export class SubjectNotes{

  public note_id?: number;
  public note_content?: string;
  public created_by?: number;
  // public created_date?: Date;
  public created_date?: any;
  public subject_id?: number;
  public job_id?: number;
  public job_reference_number?: string;
  public file_number?: number;
  public reference_number?: number;
  public subject_number?: string;
  public note_type_id?: number;
  public user_level_id?: number;
  public brand_type_id?: number;

  public subject_com_type_id?: number;
  public subject_template_doc_id?: number;
  public file_id?: number;
  public brand_id?: number;


public assigned_to_agents?: any; // default [] must.
public assigned_to_subjects?: any; // default [] must!
public assigned_from_note_id?: any; // defult null or 0

public brand_type_name?: any;
public user_name?: any;
public file_brand_name?: any;
public note_type_name?: any;

public subject_attempt_type_name?: any;
public subject_name?: any;
public last_insert_id?: any;


  // ? what does this really do? (no encoding or deserialisation required...)
/*   deserialize(input: any): SubjectNotes {
    Object.assign(this, input);

    return this;
  } */


}
